// extracted by mini-css-extract-plugin
export default {"landingDateRange":"DateRangerPicker_landingDateRange__bHriC"};